import axiosInstance from "./global-instance";
import { listingApiUrl } from "../constants/url-constants";
import createScopedApi from "./createScopedApi";

const BASE_API_URL = `${listingApiUrl()}/v1/`;

export default createScopedApi(BASE_API_URL, axiosInstance);
